<template>
  <v-textarea
    v-if="textarea"
    ref="FIELD"
    solo
    v-model.trim="localValue"
    @focus="onFocus"
    @blur="onBlur"
    :background-color="backgroundColor"
    :placeholder="placeholder"
    :readonly="readonly"
    class="no-shadow"
    dense
    hide-details
    :rows="!readonly ? 5 : 1"
    :no-resize="readonly"
    auto-grow
  >
    <template #append>
      <v-btn text @click="toggle" :loading="isLoading">
        <v-icon size="18" class="mr-1">
          {{ readonly ? 'mdi-pencil' : 'mdi-keyboard-return' }}
        </v-icon>
        {{ readonly ? $t('COMMON.WORD.EDIT') : '完成' }}
      </v-btn>
    </template>
  </v-textarea>

  <v-text-field
    v-else
    ref="FIELD"
    solo
    v-model="localValue"
    @focus="onFocus"
    @blur="onBlur"
    @keyup="(e) => e.key === 'Enter' && submit()"
    :background-color="backgroundColor"
    :placeholder="placeholder"
    :readonly="readonly"
    class="no-shadow"
    dense
    hide-details
  >
    <template #append>
      <v-btn text @click="toggle" :loading="isLoading">
        <v-icon size="18" class="mr-1">
          {{ readonly ? 'mdi-pencil' : 'mdi-keyboard-return' }}
        </v-icon>
        {{ readonly ? $t('COMMON.WORD.EDIT') : '完成' }}
      </v-btn>
    </template>
  </v-text-field>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: 'neutral700'
    },
    placeholder: {
      type: String,
      default: ''
    },
    textarea: {
      type: Boolean,
      default: false
    },
    api: {
      type: Function,
      default: () => {}
    }
  },

  data() {
    return {
      localValue: this.value,
      isLoading: false,
      readonly: true
    };
  },

  methods: {
    toggle() {
      this.readonly = !this.readonly;
      this.$nextTick(() => {
        if (this.readonly) {
          this.submit();
        } else {
          this.$refs.FIELD.$refs.input.select();
        }
      });
    },
    async submit() {
      if (this.value === this.localValue) {
        this.readonly = true;
        return;
      }
      this.isLoading = true;

      await this.api(this.localValue);

      this.$emit('input', this.localValue);

      this.readonly = true;
      this.isLoading = false;
    },
    onFocus() {
      //
    },
    onBlur() {
      this.readonly = true;
      this.localValue = this.value;
    }
  }
};
</script>

<style lang="scss" scoped>
.no-shadow {
  :deep(.v-input__slot) {
    box-shadow: none !important;
  }
}
</style>